<template>
  <section class="yield-right-panel strategy-panel">
    <div class="strategy-heading">
      <span></span>
      <h2>销售与存储策略</h2>
      <span></span>
    </div>
    <div class="strategy-list">
      <article v-for="item in strategyList" :key="item.title" class="strategy-card">
        <div class="strategy-icon">{{ item.icon }}</div>
        <div>
          <h3>{{ item.title }}</h3>
          <p>{{ item.text }}</p>
        </div>
      </article>
    </div>
  </section>
</template>

<script setup>
const strategyList = [
  { icon: "▣", title: "销售策略:", text: "小麦、玉米分批出库，优先匹配县域订单" },
  { icon: "⚑", title: "存储策略:", text: "粮食控水入仓，花生低温通风防霉变" },
  { icon: "✓", title: "效益提示:", text: "减少集中上市波动，稳定综合收益" },
];
</script>

<style lang="less" scoped>
@import "../YieldRightShared.less";

.strategy-panel {
  height: 100%;
  padding: 22px 56px 36px;
}

.strategy-heading {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  align-items: center;
  gap: 22px;
  color: #ffffff;
}

.strategy-heading span {
  height: 20px;
  border-top: 4px solid rgba(34, 255, 232, 0.72);
  border-left: 4px solid rgba(34, 255, 232, 0.72);
  transform: skewX(34deg);
}

.strategy-heading span:last-child {
  border-left: 0;
  border-right: 4px solid rgba(34, 255, 232, 0.72);
  transform: skewX(-34deg);
}

h2 {
  margin: 0;
  color: #ffffff;
  font-size: 34px;
  font-weight: 800;
  line-height: 48px;
}

.strategy-list {
  height: calc(100% - 68px);
  min-height: 0;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 34px;
  padding-top: 24px;
}

.strategy-card {
  position: relative;
  display: grid;
  grid-template-columns: 78px minmax(0, 1fr);
  align-items: center;
  gap: 20px;
  min-height: 126px;
  padding: 26px 30px;
  border: 1px solid rgba(42, 255, 232, 0.42);
  background: linear-gradient(180deg, rgba(0, 86, 78, 0.36), rgba(0, 35, 35, 0.72));
  box-shadow: inset 0 0 20px rgba(42, 255, 232, 0.12);
  box-sizing: border-box;
}

.strategy-icon {
  width: 64px;
  height: 64px;
  border: 2px solid rgba(42, 255, 232, 0.72);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #65fff2;
  font-size: 32px;
  font-weight: 800;
  background: radial-gradient(circle, rgba(0, 126, 113, 0.74), rgba(0, 42, 40, 0.88));
}

h3 {
  margin: 0 0 8px;
  color: #40fff0;
  font-size: 34px;
  font-weight: 800;
  line-height: 36px;
  text-align: left;
  margin-bottom: 20px;
}

p {
  margin: 0;
  color: #ffffff;
  font-size: 30px;
  font-weight: 700;
  line-height: 40px;
  text-align: left;
}
</style>
